import PPUtils from "../../utils/PPUtils";

const STORAGE_KEY_PREFIX = "pp-pricemanagement-channel";

function getStorageKey(customerId) {
     return `${STORAGE_KEY_PREFIX}-${customerId}`;
}

export function getStoredChannelId(customerId) {
     if (!PPUtils.isValidCustomerId(customerId)) {
          return null;
     }
     try {
          const raw = localStorage.getItem(getStorageKey(customerId));
          if (raw == null || raw === "") {
               return null;
          }
          const parsed = Number(raw);
          return Number.isInteger(parsed) && parsed >= 0 ? parsed : null;
     } catch {
          return null;
     }
}

export function setStoredChannelId(customerId, channelId) {
     const hasChannelId = Number.isInteger(channelId) && channelId >= 0;
     if (!PPUtils.isValidCustomerId(customerId) || !hasChannelId) {
          return;
     }
     try {
          localStorage.setItem(getStorageKey(customerId), String(channelId));
     } catch {
          // localStorage nicht verfügbar: Der Kanal wird dann nur nicht gemerkt.
     }
}

function isChannelId(value) {
     return Number.isInteger(value) && value >= 0;
}

function normalizeChannelList(channelList) {
     if (Array.isArray(channelList)) {
          return channelList;
     }
     if (channelList == null) {
          return [];
     }
     return [channelList];
}

export function findChannelById(channelList, channelId) {
     if (!isChannelId(channelId)) {
          return null;
     }
     const list = normalizeChannelList(channelList);
     const match = list.find((channel) => channel.id === channelId);
     return match == null ? null : match;
}

export function resolveChannelId(channelList, customerId, currentChannelId = null) {
     const list = normalizeChannelList(channelList);
     const visible = list.filter((channel) => !channel.hidden);
     const candidates = visible.length > 0 ? visible : list;

     if (candidates.length === 0) {
          return null;
     }

     const isKnownChannel = (channelId) =>
          isChannelId(channelId) && candidates.some((channel) => channel.id === channelId);

     if (isKnownChannel(currentChannelId)) {
          return currentChannelId;
     }

     const storedChannelId = getStoredChannelId(customerId);
     if (isKnownChannel(storedChannelId)) {
          return storedChannelId;
     }

     return candidates[0].id;
}

export function selectChannel(customerId, channelId, setSelectedChannelId) {
     if (isChannelId(channelId)) {
          setStoredChannelId(customerId, channelId);
          setSelectedChannelId(channelId);
          return;
     }
     if (channelId == null) {
          setSelectedChannelId(null);
     }
}
